import {Component, Input, OnInit} from '@angular/core';
import {AppService} from 'app/services/app.service';

@Component({
  selector: 'app-loader',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class LoaderComponent implements OnInit {
  @Input() public width: string = '40';
  @Input() public height: string = '40';
  @Input() public viewBox: string = '0 0 56 53';

  appService: AppService;

  constructor(
    appService: AppService
  ) {
    this.appService = appService;
  }

  ngOnInit(): void {

  }
}
